import { createApi } from '@reduxjs/toolkit/query/react';

import Resource from '@guestyci/agni';

let cachedApi = null;

const dynamicBaseQuery = async (args, api, extraOptions) => {
  if (!cachedApi) {
    cachedApi = Resource.create({
      domain: 'booking-engine-management',
      development: true,
    }).api;
  }

  return cachedApi(args, api, extraOptions);
};

export const integrationsApi = createApi({
  reducerPath: 'integrationsApi',
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: ({ query }) => ({
    getEnginesByListingIds: query({
      query: (listingIds = null) => ({
        url: '/engines/engines-by-listing-ids',
        params: {
          listingIds,
        },
      }),
    }),
  }),
});

export const { useGetEnginesByListingIdsQuery } = integrationsApi;
